export default __webpack_public_path__ + "static/media/i-info.da19dbec.svg";